// extracted by mini-css-extract-plugin
export var app = "default-module--app--aU2oH";
export var appMain = "default-module--appMain--G6jmA";